import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useSuiteStore } from './useSuiteStore'
import { withApiState } from '@/utils/withApiState'

export type ActionPriority = 'NORMAL' | 'HIGH' | 'URGENT'

export interface ActionCta {
  label?: string
  route?: string
  params?: Record<string, unknown>
}

export interface ActionItem {
  uuid: string
  type: string
  title: string
  description: string | null
  cta: ActionCta | null
  payload: any
  basePriority: ActionPriority
  effectivePriority: ActionPriority
  urgentAt: string | null
  dueAt: string | null
  entityType: string | null
  entityId: string | null
  openedAt: string
}

interface ActionCount {
  total: number
  urgent: number
  high: number
  normal: number
}

/**
 * Liste « À faire » (actions). Distincte de useUserNotificationStore (FYI) :
 * ces items se ferment sur l'événement métier, pas sur une lecture.
 */
export const useActionItemStore = defineStore('actionItem', () => {
  const items = ref<ActionItem[]>([])
  const count = ref<ActionCount>({ total: 0, urgent: 0, high: 0, normal: 0 })
  const isLoading = ref(false)

  const fetchActions = async () => {
    const suiteStore = useSuiteStore()
    await withApiState(
      async () => {
        const response = await suiteStore.suiteFetch('action-items', { credentials: 'include' })
        if (response && typeof response !== 'boolean' && response.ok) {
          const result = await response.json()
          items.value = result.data
        }
      },
      { loading: isLoading, logLabel: 'Erreur lors de la récupération des actions:' },
    )
  }

  const fetchCount = async () => {
    const suiteStore = useSuiteStore()
    await withApiState(
      async () => {
        const response = await suiteStore.suiteFetch('action-items/count', { credentials: 'include' })
        if (response && typeof response !== 'boolean' && response.ok) {
          const result = await response.json()
          count.value = result.data
        }
      },
      { logLabel: 'Erreur lors de la récupération du compteur d\'actions:' },
    )
  }

  return { items, count, isLoading, fetchActions, fetchCount }
})
